import { render, staticRenderFns } from "./DropdownTarget.vue?vue&type=template&id=aae49c42&"
import script from "./DropdownTarget.vue?vue&type=script&lang=js&"
export * from "./DropdownTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports